(function ($) {
    
    function careerLoadmore(loadbtn){
        $(loadbtn).click(function(){

            var button = $(this),
                data = {
                'action': 'career_loadmore',
                'query': career_posts_myajax,
                'page' : career_filter_page_myajax
            };

            $.ajax({
                url : career_ajaxurl, // AJAX handler
                data : data,
                type : 'POST',
                beforeSend : function ( xhr ) {
                    button.text('Loading...'); // change the button text, you can also add a preloader image
                },
                success : function( data ){
                    if( data ) { 
//                        button.text( 'Load More' ).prev().after(data); // insert new posts
                        button.text( 'Load More' ).parent().prev().after(data); // insert new posts
                        
                        career_filter_page_myajax++;
                        
                        if ( career_filter_page_myajax == career_max_page_myajax )
                            button.remove(); // if last page, remove the button
                    } else {
                        button.text( 'No data' );
                    }
                }
            });
        });	
    };
    
    careerLoadmore('.career_filter_loadmore');
    
    $('#career_filter').submit(function(){
		var filter = $('#career_filter');
		$.ajax({
			url:filter.attr('action'),
			data:filter.serialize(), // form data
			type:filter.attr('method'), // POST
			beforeSend:function(xhr){
				filter.find('button').text('Loading...'); // changing the button label
			},
			success : function( data ){
				filter.find('button').text('Search'); // changing the button label back
				$('#career_results').html(data); // insert data
                
//                console.log(data);
                
                careerLoadmore('.career_filter_loadmore');
			}
		});
		return false;
	});
    
    
    
    
    $('#career_filter_toggle').click(function(){
        $(this).toggleClass('active').next().slideToggle();
    });

	/* Document Ready */
	$(document).ready(function() {
        
        // Select2
        if($('.career-filter-block').length){
            
            $('.career-filter-block').find('select').each(function() {
                var dropdownParent = $(this).parent();
                $(this).select2({
                    dropdownParent: dropdownParent
                });
                
            });
        }
	});

})(jQuery);